import IconDisc from "@web-ui/components/IconDisc";
import type { Tone } from "@web-ui/types/tone";

/*
 * Stat: one figure in a hairline tile, the Tixora metric card (owner 2026-10-13; it replaces the tiles
 * the dashboard and the portal each drew): the label and an icon disc on the first line, the figure, a
 * quiet note under it. The tone colours the disc, never the figure. The figure is data: it changes
 * instantly, never animates (wrap it in motion-swap at the call site if the container should cross
 * fade). Styles in styles/data-display.css .stat.
 */
type StatProps = {
    className?: string;
    label: React.ReactNode;
    value: React.ReactNode;
    note?: React.ReactNode;
    tone?: Tone;
    /** A kit icon name, drawn in a small disc at the end of the label line. */
    icon?: string;
};

const Stat = ({ className, label, value, note, tone = "neutral", icon }: StatProps) => (
    <div className={`stat ${className || ""}`} data-tone={tone}>
        <div className="stat__head">
            <span className="stat__label">{label}</span>
            {icon ? <IconDisc tone={tone} icon={icon} size="sm" /> : null}
        </div>
        <div>
            <div className="stat__value">{value}</div>
            {note ? <div className="stat__note">{note}</div> : null}
        </div>
    </div>
);

export default Stat;

/*
 * StatGrid: Stats side by side. Without `columns` as many 12rem tiles as fit; with it, that many across
 * (3 and 4 fall to 2 under lg); one column on a phone. The tiles arrive one after the other
 * (motion-stagger).
 */
type StatGridProps = {
    className?: string;
    columns?: 2 | 3 | 4;
    children: React.ReactNode;
};

export const StatGrid = ({ className, columns, children }: StatGridProps) => (
    <div className={`stat-grid ${columns ? `stat-grid--${columns}` : ""} motion-stagger ${className || ""}`}>{children}</div>
);
